
import AppBrowse from "@/components/browse/Browse.vue";
import { Contact } from "@/models/base";
import { View } from "@/models/view";
import { BrowseService } from "@/services/browse-service";
import { ToolbarService } from "@/services/toolbar-service";
import { IBrowseDataSource } from "@/utils/browse/browse-data-source";
import { FetchedTotal } from "@/utils/views/fetched-total";
import Vue from "vue";
import AppImportCsvModal from "../../components/contacts/ImportCsvModal.vue";
import { SupplierService } from "../../services/supplier-service";
import { UserConfigService } from "../../services/user-config-service";
import { BrowseState } from "@/utils/browse/browse-state";
import { AuthService, DossierConfigService } from "@/services";
import {ISelectItem} from "winfakt-vue-components";
import AppSendMessageDialog from "@/components/mail/SendMessageDialog.vue";
import { getContactServiceByGroupId } from "@/utils/services/contact-services";
import { ContactService } from "@/utils/services/contact-service";
import AppExcelMapper from "@/components/contacts/ExcelMapperWrapper.vue";
import { MODULE } from "@/config/modules";

export default Vue.extend({
	data() {
		return {
			uploadCSVModal: false,
			selectedItems: [] as Contact[],
			browseState: null as null | BrowseState,
			sendMessageDialogContact: null as null | Contact,
			excelMapperOpen: false
		};
	},
	props: {
		browseId: Number,
		controlsDisabled: Boolean,
		searchEnabled: Boolean,
		isSearchOnly: Boolean
	},
	computed: {
		buttonBarItems():ISelectItem<string | Function>[]{
			let result = [] as ISelectItem<string | Function>[];
			if (this.canWrite){
				result.push({
						text: this.$ct("tooltip.import-csv").toString(),
						value: "open-import-csv-modal",
						icon: "upload",
						disabled: !AuthService.hasModule(MODULE.IMPORT)
					},
					{
						text: this.$ct("excel-conversion"),
						value: ()=>this.excelMapperOpen = true,
						icon: "file-excel"
					}
				);
			}
			if (AuthService.isDevModeEnabled){
				result.push({
					text: "Contacten opnieuw opslaan",
					value: this.resaveContacts,
					icon: "save"
				});
			}
			return result;
		},
		baseRoutePath():string{
			return "/contacts/suppliers";
		},
		dataSource(): IBrowseDataSource<Contact> {
			let elem = this;
			return {
				getFullElement: (el:Contact)=>SupplierService.getContact(el.ID),
				getSettings: () => BrowseService.getBrowse(this.browseId),
				getElements: SupplierService.getContacts.bind(SupplierService),
				getTotals(view:View):Promise<FetchedTotal[]>{
					return SupplierService.getTotals(view);
				},
				edit(contact: Contact) {
					elem.$router.push(`${elem.baseRoutePath}/edit/${contact.ID}`);
				},
				async delete(contacts: Contact[]) {
					await SupplierService.delContacts(contacts);
					return true;
				},
				addRoute: `${elem.baseRoutePath}/new`,
				browseName: "Suppliers",
				modelName: "Contact",
				info(contact:Contact){
					elem.$router.push(SupplierService.getInfoRoute(contact.ID));
				},
				browsePermissions: ()=>UserConfigService.getPermissionSettings().SupplierPermissions,
				extraFieldSettings: {
					getExtraFields: SupplierService.getExtraFields.bind(SupplierService),
					nameSettings: DossierConfigService.getExtraFieldNamesConfigs().ProspectNames,
					batchEdit: SupplierService.batchEditExtraField.bind(SupplierService),
					edit: (SupplierService.updateExtraFields as any).bind(SupplierService)
				}
			};
		},
		canWrite():boolean {
			return UserConfigService.hasCurrentUserPermission((p)=>p.SupplierPermissions.hasWritePermissions());
		},
		contactService():ContactService{
			return getContactServiceByGroupId(2);
		},
	},
	watch: {
		"$route.path": {
			immediate: true,
			handler(){
				if (this.$route.path.split("/").length == 3){
					ToolbarService.title = this.$ct("titles.suppliers");
				}
			}
		}
	},
	methods: {
		onSearchItemSelected(contact:Contact) {
			this.$emit("search-item-selected", contact);
		},
		async updateView(){
			if (!this.browseState) return;
			await this.browseState.fetch();
		},
		openImportCsvModal(){
			this.uploadCSVModal = true;
		},
		async resaveContacts(){
			await SupplierService.resaveContacts(this.selectedItems.map(c=>c.ID));
			this.$wf.notify("Contacten opnieuw opslaan is gestart", "info", 3000, "info-circle");
		},
		onColClick(result:string, value:Contact){
			if (result == "send-mail") {
				this.sendMessageDialogContact = value;
			}
		},
		closeSendMessageDialog(){
			this.sendMessageDialogContact = null;
		}
	},
	components: {
		AppBrowse,
		AppImportCsvModal,
		AppSendMessageDialog,
		AppExcelMapper
	},
	i18nEx: {
		componentPrefix: "components.contacts"
	},
});
